import { Photo, Photos } from 'components/page/ForeignProfile/common.types'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'

import {
  filteredPortraitNotMainPhotos,
  filteredRestPhotos,
} from '../function/filterPhotos'

const emptyPhotos = {
  mobilePhotos: [],
  mobileGoalPhoto: undefined,
  mobileInterestsPhoto: undefined,
  mobileSocialPhoto: undefined,
}

/**
 * @param data
 * Фотография для профиля в мобильной версии
 */
export const useMobilePhotos = (
  profile: GQLForeignRootQuery['user']
): {
  mobilePhotos: Photos | undefined
  mobileGoalPhoto: Photo | undefined
  mobileInterestsPhoto: Photo | undefined
  mobileSocialPhoto: Photo | undefined
} => {
  if (!profile) {
    return { ...emptyPhotos }
  }

  const photos = profile.photos.photos.nodes
  const dating = profile.dating
  const isSocialBlock = Boolean(
    dating.materialStatus ||
      dating.homeStatus ||
      dating.children ||
      dating.education ||
      dating.knownLanguages ||
      dating.smoking ||
      dating.alcohol
  )

  const isForeignInterests = profile.interests.interests.nodes.length > 0

  if (photos.length > 0) {
    const _secondaryPhotos = filteredPortraitNotMainPhotos(photos)
    const _restPhotos = filteredRestPhotos(photos)

    if (_secondaryPhotos.length > 3) {
      const _secondarySlicePhotos = _secondaryPhotos.slice(0, 3)
      const _restMergePhotos = [..._secondaryPhotos.slice(3), ..._restPhotos]

      return findPhotos(
        _secondarySlicePhotos,
        _restMergePhotos,
        isForeignInterests,
        isSocialBlock
      )
    } else {
      return findPhotos(
        _secondaryPhotos,
        _restPhotos,
        isForeignInterests,
        isSocialBlock
      )
    }
  }

  return { ...emptyPhotos }
}

const findPhotos = (
  photos: Photos,
  restPhotos: Photos,
  isForeignInterests: boolean,
  isSocialBlock: boolean
) => {
  if (photos.length === 3) {
    if (isForeignInterests && isSocialBlock) {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: photos[1],
        mobileSocialPhoto: photos[2],
        mobilePhotos: restPhotos,
      }
    }

    if (!isForeignInterests && !isSocialBlock) {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: undefined,
        mobileSocialPhoto: undefined,
        mobilePhotos: [...photos.slice(1), ...restPhotos],
      }
    }

    if (isForeignInterests) {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: photos[1],
        mobileSocialPhoto: undefined,
        mobilePhotos: [...photos.slice(2), ...restPhotos],
      }
    }

    if (isSocialBlock) {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: undefined,
        mobileSocialPhoto: photos[1],
        mobilePhotos: [...photos.slice(2), ...restPhotos],
      }
    }
  }

  if (photos.length === 2) {
    if (isForeignInterests) {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: photos[1],
        mobileSocialPhoto: undefined,
        mobilePhotos: restPhotos,
      }
    } else if (isSocialBlock) {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: undefined,
        mobileSocialPhoto: photos[1],
        mobilePhotos: restPhotos,
      }
    } else {
      return {
        mobileGoalPhoto: photos[0],
        mobileInterestsPhoto: undefined,
        mobileSocialPhoto: undefined,
        mobilePhotos: [...photos.slice(1), ...restPhotos],
      }
    }
  }

  if (photos.length === 1) {
    return {
      mobileGoalPhoto: photos[0],
      mobileInterestsPhoto: undefined,
      mobileSocialPhoto: undefined,
      mobilePhotos: restPhotos,
    }
  }

  return {
    ...emptyPhotos,
    mobilePhotos: restPhotos,
  }
}
